import { jsx as _jsx } from "react/jsx-runtime";
import { getTestIds } from 'seagull/utils/TestIds';
import { StepsContainerDesktop } from './StepsContainerDesktop';
import { StepsContainerMobile } from './StepsContainerMobile';
export const GetStepsContainerTID = (parentTestId)=>getTestIds({
        parentTestId
    });
export const StepsContainer = (param)=>{
    let { testId, currentStep, direction, onBack, onNext, relationship, isMobile, statement, isStatementAccepted, onStatementChange, isNextDisabled, hideNextButton, hasSignedSuccess } = param;
    if (isMobile) {
        return /*#__PURE__*/ _jsx(StepsContainerMobile, {
            testId: testId,
            currentStep: currentStep,
            direction: direction,
            relationship: relationship,
            statement: statement,
            isStatementAccepted: isStatementAccepted,
            onStatementChange: onStatementChange,
            hasSignedSuccess: hasSignedSuccess
        });
    }
    return /*#__PURE__*/ _jsx(StepsContainerDesktop, {
        testId: testId,
        currentStep: currentStep,
        direction: direction,
        onBack: onBack,
        onNext: onNext,
        relationship: relationship,
        statement: statement,
        isStatementAccepted: isStatementAccepted,
        onStatementChange: onStatementChange,
        isNextDisabled: isNextDisabled,
        hideNextButton: hideNextButton,
        hasSignedSuccess: hasSignedSuccess
    });
};
